import { httpPost } from './apiService';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';
import { ArticleEntity } from '@models/article';

export abstract class ArticleEntityAdminService<
    Entity extends ArticleEntity
> extends SlugEntityAdminApiService<Entity> {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public async duplicate(article: Entity, id: number): Promise<number | undefined> {
        const response = await httpPost(`${this.baseUrl}/duplicate/${id}`, JSON.stringify(article));

        return this.returnResult<number>(await response.json());
    }
}
